import React from 'react';
import { Link } from 'react-router-dom';
import './LandingPage.css';

function LandingPage() {
  return (
    <div className="landing">
      <div className="bg-animation"></div>
      
      <nav id="navbar">
        <div className="nav-container">
          <div className="logo">Scalesman</div>
          <div className="nav-links">
            <a href="#features">Features</a>
            <a href="#demo">Demo</a>
            <a href="#pricing">Pricing</a>
            <Link to="/dashboard" className="cta-button">Start Building</Link>
          </div>
        </div>
      </nav>

      <section className="hero">
        <div className="hero-content">
          <h1>Build Apps with Pure Vibes</h1>
          <p>The no-code platform where creativity flows and apps come to life</p>
          <div className="hero-buttons">
            <Link to="/dashboard" className="primary-btn">Create Your First App</Link>
            <a href="#demo" className="secondary-btn">Watch It Work</a>
          </div>
        </div>
      </section>
      
      {/* Rest of your landing page content */}
    </div>
  );
}
<Link to="/dashboard" className="cta-button" onClick={() => console.log('Button clicked!')}>
  Start Building
</Link>
export default LandingPage;